import React from "react";
import { Link } from "react-router-dom";

import Constants from "app_constants";
import Theme from "./theme";

const PrivacyPolicy = () => {
  return (
    <Theme>
      {Constants.metaTag}

      <div className="box">
        <h4 className="title is-4">
          "Terms & Conditions" and "Privacy Policy"
        </h4>

        <strong>1-) Introduction</strong>
        <br />
        <br />
        <p>
          These Website Standard Terms and Conditions written on this webpage
          shall manage your use of this website. These Terms will be applied
          fully and affect to your use of this Website. By using this Website,
          you agreed to accept all terms and conditions written in here. You
          must not use this Website if you disagree with any of these Website
          Standard Terms and Conditions.
        </p>
        <br />
        <p>
          Minors or people below 18 years old are not allowed to use this
          Website.
        </p>
        <br />
        <p>
          The minimal hardware requirements of the device that will be used by
          the client are: Computer, Web Browser.
        </p>
        <p>
          Remote Jobs platform allows its' users to publish &amp; search
          remote-only job ads.
        </p>
        <p>
          There is a possibility to terminate the agreement by the client
          (customer), without giving a reason, within 1 day.
        </p>
        <br />
        <strong>2-) Intellectual Property Rights</strong>
        <br />
        <br />
        <p>
          Other than the content you own, under these Terms, Remote Jobs and/or
          its licensors own all the intellectual property rights and materials
          contained in this Website.
        </p>
        <p>
          You are granted limited license only for purposes of viewing the
          material contained on this Website.
        </p>
        <br />
        <strong>3-) Restrictions</strong>
        <br />
        <br />
        <p>You are specifically restricted from all of the following:</p>
        <ul>
          <li>publishing any Website material in any other media;</li>
          <li>
            selling, sublicensing and/or otherwise commercializing any Website
            material;
          </li>
          <li>publicly performing and/or showing any Website material;</li>
          <li>
            using this Website in any way that is or may be damaging to this
            Website;
          </li>
          <li>
            using this Website in any way that impacts user access to this
            Website;
          </li>
          <li>
            using this Website contrary to applicable laws and regulations, or
            in any way may cause harm to the Website, or to any person or
            business entity;
          </li>
          <li>
            engaging in any data mining, data harvesting, data extracting or any
            other similar activity in relation to this Website;
          </li>
          <li>using this Website to engage in any advertising or marketing.</li>
        </ul>
        <br />
        <p>
          Certain areas of this Website are restricted from being access by you
          and Remote Jobs may further restrict access by you to any areas of
          this Website, at any time, in absolute discretion. Any user ID and
          password you may have for this Website are confidential and you must
          maintain confidentiality as well.
        </p>
        <br />
        <strong>4-) Your Content</strong>
        <br />
        <br />
        <p>
          In these Website Standard Terms and Conditions, “Your Content” shall
          mean any audio, video text, images or other material you choose to
          display on this Website. By displaying Your Content, you grant Remote
          Jobs a non-exclusive, worldwide irrevocable, sub licensable license to
          use, reproduce, adapt, publish, translate and distribute it in any and
          all media.
        </p>
        <p>
          Your Content must be your own and must not be invading any
          third-party’s rights. Remote Jobs reserves the right to remove any of
          Your Content from this Website at any time without notice.
        </p>
        <br />
        <strong>5-) No warranties</strong>
        <br />
        <br />
        <p>
          This Website is provided “as is” with all faults, and Remote Jobs
          express no representations or warranties, of any kind related to this
          Website or the materials contained on this Website. Also, nothing
          contained on this Website shall be interpreted as advising you.
        </p>
        <br />
        <strong>6-) Limitation of liability</strong>
        <br />
        <br />
        <p>
          In no event shall Remote Jobs, nor any of its officers, directors and
          employees, shall be held liable for anything arising out of or in any
          way connected with your use of this Website whether such liability is
          under contract. &nbsp;Remote Jobs, including its officers, directors
          and employees shall not be held liable for any indirect, consequential
          or special liability arising out of or in any way related to your use
          of this Website.
        </p>
        <br />
        <strong>7-) Indemnification</strong>
        <br />
        <br />
        <p>
          You hereby indemnify to the fullest extent Remote Jobs from and
          against any and/or all liabilities, costs, demands, causes of action,
          damages and expenses arising in any way related to your breach of any
          of the provisions of these Terms.
        </p>
        <br />
        <strong>8-) Severability</strong>
        <br />
        <br />
        <p>
          If any provision of these Terms is found to be invalid under any
          applicable law, such provisions shall be deleted without affecting the
          remaining provisions herein.
        </p>
        <br />
        <strong>9-) Variation of Terms</strong>
        <br />
        <br />
        <p>
          Remote Jobs is permitted to revise these Terms at any time as it sees
          fit, and by using this Website you are expected to review these Terms
          on a regular basis.
        </p>
        <br />
        <strong>10-) Assignment</strong>
        <br />
        <br />
        <p>
          The Remote Jobs is allowed to assign, transfer, and subcontract its
          rights and/or obligations under these Terms without any notification.
          However, you are not allowed to assign, transfer, or subcontract any
          of your rights and/or obligations under these Terms.
        </p>
        <br />
        <strong>11-) Entire Agreement</strong>
        <br />
        <br />
        <p>
          These Terms constitute the entire agreement between Remote Jobs and
          you in relation to your use of this Website, and supersede all prior
          agreements and understandings.
        </p>
        <br />
        <strong>12-) Governing Law &amp; Jurisdiction</strong>
        <br />
        <br />
        <p>
          These Terms will be governed by and interpreted in accordance with the
          laws of the State of Turkey, and you submit to the non-exclusive
          jurisdiction of the state and federal courts located in Turkey for the
          resolution of any disputes.
        </p>
        <br />
        <strong>13-) Data Protection</strong>
        <br />
        <br />
        <p>
          Use of this site requires personal data processing of a client in the
          following matter: First name and last name, phone number, e-mail,
          billing address. Data will be processed by Remote Jobs in a way that
          is crucial to agreeing on a contract, as well as its fulfillment. A
          client has the right to see the content of his data and any
          corrections made to it. Sharing of information is voluntary, however,
          at the same time it is crucial to using this site.
        </p>
        <br />
        <p>
          If you have any questions or concerns you can contact us by clicking{" "}
          <Link to="/contact">here</Link>.
        </p>
        <br />
      </div>
    </Theme>
  );
};

export default PrivacyPolicy;
